import angular, { IWindowService } from 'angular';

export class LocalStorageService {
  static $inject = ['$window'];

  constructor(private $window: IWindowService) {}

  clear(): void {
    this.$window.localStorage.clear();
  }

  getItem<T>(key: string): T | null {
    try {
      const json = this.$window.localStorage.getItem(key);
      return json == null ? null : JSON.parse(json);
    } catch (error) {
      return null;
    }
  }

  removeItem(key: string): void {
    this.$window.localStorage.removeItem(key);
  }

  setItem<T>(key: string, value: T): void {
    this.$window.localStorage.setItem(key, JSON.stringify(value));
  }
}

export const LocalStorageServiceModule = angular
  .module('acme.common.service.storage.localStorage', [])
  .service('LocalStorageService', LocalStorageService).name;
